import {type LinkBaseProps, cn} from '@tempmee/core'
import {type AnchorHTMLAttributes, forwardRef} from 'react'
import {linkVariants} from './Variants'

export interface LinkProps
  extends LinkBaseProps,
    // `LinkBaseProps` owns `color` and `children`; the anchor supplies the rest
    // (`href`, `target`, `onClick`, …). `color` is also the deprecated HTML attr.
    Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'color' | 'children'> {}

/**
 * Text hyperlink following MUI's `Link` contract. Renders a semantic `<a>` and
 * exposes `color` (`primary` | `inherit`) and `underline` (`always` | `hover` |
 * `none`). Inherits font size from its surrounding text so it blends into body
 * copy; pass `href` (and any anchor attributes) as normal.
 */
export const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({className, color = 'primary', underline = 'always', children, ...props}, ref) => (
    <a ref={ref} className={cn(linkVariants({color, underline}), className)} {...props}>
      {children}
    </a>
  ),
)
Link.displayName = 'Link'
